import { Directive, ElementRef, HostListener } from '@angular/core';

@Directive({
  selector: '[Onlytext]'
})
export class OnlytextDirective {



  constructor(private el: ElementRef) { }


  @HostListener('input', ['$event'])
  onInput(event: Event) {
    let initialValue: string = this.el.nativeElement.value;

    // Remove numbers and special characters (except space)
    initialValue = initialValue.replace(/[^A-Za-z\s]/g, '')
                               .replace(/^\s+/g, '') // Remove leading spaces
                               .replace(/\s{2,}/g, ' '); // Replace multiple spaces with a single space

    this.el.nativeElement.value = initialValue;
  }

  // @HostListener('paste', ['$event'])
  // blockPaste(event: ClipboardEvent): void {  
  //   event.preventDefault();
  //   const pastedValue = event.clipboardData?.getData('text') || '';
  //   const sanitizedValue = pastedValue.replace(/[^a-zA-Z\s]+/g, '').replace(/^\s+/g, '').replace(/\s{2,}/g, ' ');
  //   this.el.nativeElement.value = sanitizedValue;
  //   if (sanitizedValue !== this.el.nativeElement.value) {
  //     event.stopPropagation();
  //   }
  // }

}
